export function setupAppMakerGlobalVariable() {
  if (!window['appMaker']) window['appMaker'] = {};
  return window['appMaker'];
}
export function getAppMakerGlobalVariable(field) {
  return setupAppMakerGlobalVariable()[field];
}
export function setAppMakerGlobalVariable(key, value) {
  setupAppMakerGlobalVariable()[key] = value;
}
export function platformIsMobile() {
  return getAppMakerGlobalVariable('platform') === 'mobile';
}
/**
 * 根据当前页面地址获取页面信息，如：应用预览页/#/preview/815/4505  返回{'name':'preview','path':'/preview/818/4505'}
 */
export function getAppPageInfo() {
  let res = {
    name: '',
    path: ''
  };
  let map = {
    preview: {
      name: 'preview',
      regexp: /\/preview\/(\d+)\/\d+/gi
    },
    app: {
      name: 'app',
      regexp: /\/app\/(\d+)(\/\d+)?/gi
    },
    editor: {
      name: 'editor',
      regexp: /\/editor\/page\/(\d+)\/\d+/gi
    }
  };
  for (let item in map) {
    let match = map[item].regexp.exec(location.href);
    if (match) {
      res = {
        ...map[item],
        path: match[0]
      };
      break;
    }
  }
  return res;
}